import { useAskInputSourceSuggestions } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSourceSuggestions.js';
import { useGlobalAvailableSources } from '#pplx/frontend/apps/ask/hooks/shared-source-selection-hooks/useSharedSourceSelection.js';
const MAX_SUGGESTIONS = 2;
const MAX_SUGGESTIONS_WITH_SOURCES = 1;
export const useAskInputSuggestions = ({ showSources = true, isComputer = false, onSourceMentionSelect, } = {}) => {
    const { sources } = useGlobalAvailableSources();
    const hasNonWebSources = sources.some((s) => s !== 'web');
    const maxSuggestions = hasNonWebSources ? MAX_SUGGESTIONS_WITH_SOURCES : MAX_SUGGESTIONS;
    const sourceSuggestionProps = useAskInputSourceSuggestions({
        enabled: showSources && !isComputer,
        maxSuggestions,
        onSourceMentionSelect,
        productSurface: isComputer ? 'computer' : 'ask',
    });
    return { sourceSuggestionProps };
};
//# sourceMappingURL=useAskInputSuggestions.js.map